import _ from 'lodash';

export const getCreateOrUpdateNoteActionPayload = state => {
  return _.get(
    state,
    'pages.tenderResponse.detail.notes.createOrUpdateActionPayload',
    {}
  );
};
